import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'

export default {
  data() {
    return {
      exportTaskId: null,
      exportTaskLoop: null,
      exportTaskResult: {}
    }
  },
  computed: {
    exportTaskEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `task-histories/${this.exportTaskId}?expand=task`
      })
    }
  },
  methods: {
    startExportTaskPolling(url, payload) {
      return RestApi.post(url, payload).then(({ data }) => {
        this.exportTaskId = data.task_id
        this.fetchExportTaskResult()
        this.exportTaskLoop = setInterval(() => {
          this.fetchExportTaskResult()
        }, 2000)
      })
    },
    fetchExportTaskResult() {
      RestApi.get(this.exportTaskEndpoint.url).then(({ data }) => {
        this.exportTaskResult = data
      })
    },
    stopExportTaskPolling() {
      clearInterval(this.exportTaskLoop)
      this.exportTaskId = null
      this.exportTaskResult = {}
    },
    handleExportTaskStatus(success, error) {
      switch (this.exportTaskResult.status) {
        case 2:
          clearInterval(this.exportTaskLoop)
          success()
          break

        case 3:
        case 4:
          clearInterval(this.exportTaskLoop)
          error()
          break
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/audiences/mixins/taskPollingMixin.js